import { render, staticRenderFns } from "./CloseServiceOrder.vue?vue&type=template&id=164dd5be&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./CloseServiceOrder.vue?vue&type=style&index=0&id=164dd5be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164dd5be",
  null
  
)

export default component.exports